((document) => {
  const ARIA_HIDDEN_CONTAINERS = '#app, #shopify-section-footer, #oke-reviews-widget-section';
  const FOCUSABLE_SELECTOR = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
    'summary',
    '[contenteditable="true"]'
  ].join(', ');

  const disableFocusIn = (container) => {
    container.querySelectorAll(FOCUSABLE_SELECTOR).forEach((el) => {
      if (el.hasAttribute('data-a11y-focus-managed')) return;

      el.setAttribute('data-a11y-focus-managed', 'true');
      el.setAttribute('data-a11y-prev-tabindex', el.hasAttribute('tabindex') ? el.getAttribute('tabindex') : 'none');
      el.setAttribute('tabindex', '-1');
    });
  };

  const restoreFocusIn = (container) => {
    container.querySelectorAll('[data-a11y-focus-managed]').forEach((el) => {
      const prevTabindex = el.getAttribute('data-a11y-prev-tabindex');

      if (prevTabindex === 'none') {
        el.removeAttribute('tabindex');
      } else {
        el.setAttribute('tabindex', prevTabindex);
      }

      el.removeAttribute('data-a11y-prev-tabindex');
      el.removeAttribute('data-a11y-focus-managed');
    });
  };

  const manageAriaHiddenFocus = (container) => {
    if (!container) return;

    if (container.getAttribute('aria-hidden') === 'true') {
      disableFocusIn(container);
    } else {
      restoreFocusIn(container);
    }
  };

  const manageAllContainers = () => {
    document.querySelectorAll(ARIA_HIDDEN_CONTAINERS).forEach(manageAriaHiddenFocus);
  };

  const handleSkipLink = (event) => {
    const link = event.target.closest('[data-skip-content]');
    if (!link) return;

    const target = document.getElementById('main_content');
    if (!target) return;

    event.preventDefault();
    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: false });
  };

  const nestOrphanedLists = () => {
    document.querySelectorAll('.rte ul, .rte ol').forEach((list) => {
      Array.from(list.children).forEach((child) => {
        if (child.tagName !== 'UL' && child.tagName !== 'OL') return;

        const previousItem = child.previousElementSibling;
        if (previousItem && previousItem.tagName === 'LI') {
          previousItem.appendChild(child);
          return;
        }

        const wrapper = document.createElement('li');
        wrapper.style.listStyle = 'none';
        list.insertBefore(wrapper, child);
        wrapper.appendChild(child);
      });
    });
  };

  const ensureMediaCaptions = () => {
    const isPagefly = (el) => !!(
      el.closest('#__pf') ||
      el.closest('[data-pf-type]') ||
      el.closest('[class*="pagefly"]')
    );

    let captionsHref = '';
    const existingTrack = document.querySelector('video track[kind="captions"][src], video track[kind="Captions"][src], audio track[kind="captions"][src], audio track[kind="Captions"][src]');
    if (existingTrack) {
      captionsHref = existingTrack.getAttribute('src');
    }
    if (!captionsHref) {
      captionsHref = URL.createObjectURL(new Blob(['WEBVTT\n\n'], { type: 'text/vtt' }));
    }

    document.querySelectorAll('video, audio').forEach((media) => {
      if (isPagefly(media)) return;
      if (media.querySelector('track[kind="captions"], track[kind="Captions"]')) return;

      const track = document.createElement('track');
      track.kind = 'captions';
      track.label = 'English';
      track.srclang = 'en';
      track.src = captionsHref;
      media.appendChild(track);
    });
  };

  document.addEventListener('click', handleSkipLink);

  const observer = new MutationObserver((mutations) => {
    let shouldUpdate = false;

    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
        manageAriaHiddenFocus(mutation.target);
        return;
      }

      if (mutation.type === 'childList') {
        document.querySelectorAll(`${ARIA_HIDDEN_CONTAINERS}[aria-hidden="true"]`).forEach((container) => {
          if (container.contains(mutation.target)) {
            shouldUpdate = true;
          }
        });
      }
    });

    if (shouldUpdate) {
      manageAllContainers();
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-hidden']
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      nestOrphanedLists();
      ensureMediaCaptions();
      manageAllContainers();
    }, { once: true });
  } else {
    nestOrphanedLists();
    ensureMediaCaptions();
    manageAllContainers();
  }
})(document);
